/**
 * Compact visual indicator for container gyro/buzzer states (smaller size).
 *
 * Props
 *  - alertLight: {
 *      alertLightActive: Boolean,
 *      alertLightLastMessage: "GYRO_RED" | "GYRO_OFF" | "GYRO_GREEN" | "GYRO_RED+BUZZER"
 *    }
 *  - t: i18next translate function (passed from parent)
 */
const AlertLightIndicator = ({ alertLight, t }) => {
  if (!alertLight?.alertLightActive) return null;
  const { alertLightLastMessage: msg } = alertLight;

  // Reduced dimensions: w-6 h-6 instead of w-8 h-8
  const circleBase =
    "inline-flex items-center justify-center w-6 h-6 rounded-full";

  const config = {
    GYRO_GREEN: {
      bg: "bg-green-500",
      icon: <i className="fas fa-thumbs-up text-white text-sm" />,
      title: t("No errors detected"),
    },
    GYRO_OFF: {
      bg: "bg-gray-300",
      iconJSX: <span className="text-white text-lg">⏻</span>,
      title: t("Light switched off"),
    },
    GYRO_RED: {
      bg: "bg-[var(--akanthas-red)]",
      icon: <i className="fas fa-thumbs-down text-white text-sm" />,
      title: t("Recycling errors detected"),
    },
    "GYRO_RED+BUZZER": {
      // title only; handle rendering specially
      title: t("Declassification warning"),
    },
  };

  const state = config[msg];
  if (!state) return null;

  // Special-case the combined red + buzzer
  if (msg === "GYRO_RED+BUZZER") {
    return (
      <div className="inline-flex items-center gap-1" title={state.title}>
        {/* red thumbs-down circle */}
        <span className={`${circleBase} bg-[var(--akanthas-red)]`}>
          <i className="fas fa-thumbs-down text-white text-sm" />
        </span>
        <span className="inline-flex items-center justify-center w-6 h-6">
          <span className="text-[var(--akanthas-red)] text-lg">🚫</span>
        </span>
      </div>
    );
  }

  // Default single-indicator case
  return (
    <span className={`${circleBase} ${state.bg}`} title={state.title}>
      {state.iconJSX ?? state.icon}
    </span>
  );
};

export default AlertLightIndicator;
